import upperFirst from 'lodash/upperFirst'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TableCellProps } from 'react-virtualized'

import { BestMileStops } from 'src/api/gen/api'
import { FullExportableTable } from 'src/components/Table/Templates/FullExportableTable'
import { enumCellRenderer } from 'src/components/Table/utils'

interface IProps {
  data: BestMileStops[]
  onClickExport?: (event: React.MouseEvent<HTMLElement>) => any
  totalCount: number
}

function StopsTable(props: IProps) {
  const { t } = useTranslation()

  const columns = [
    {
      label: upperFirst(t('stops.id')),
      width: 100,
      dataKey: 'id',
      cellRenderer: (cellProps: TableCellProps) => {
        const stop = cellProps.rowData as BestMileStops
        return <div>${stop.id}</div>
      },
    },
    {
      label: upperFirst(t('stops.name')),
      width: 120,
      dataKey: 'name',
      cellRenderer: (cellProps: TableCellProps) => enumCellRenderer(cellProps, (name: string) => upperFirst(name)),
    },
  ]

  // I don't get why but without that div the content of the table is not displayed.
  return (
    <FullExportableTable
      data={props.data}
      columns={columns}
      totalCount={props.totalCount}
      onClickExport={props.onClickExport}
      displayLogo={false}
    />
  )
}

export default StopsTable
